/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CloseEmailRequestData } from '../model/closeEmailRequestData';
import { EmailContentResponse } from '../model/emailContentResponse';
import { EmailSearchResponse } from '../model/emailSearchResponse';
import { EmailTemplateResponse } from '../model/emailTemplateResponse';
import { MarkEmailActiveRequestData } from '../model/markEmailActiveRequestData';
import { MarkEmailUndoneRequestData } from '../model/markEmailUndoneRequestData';
import { MoveEmailRequestData } from '../model/moveEmailRequestData';
import { NoContentResult } from '../model/noContentResult';
import { OpenEmailRequestData } from '../model/openEmailRequestData';
import { ParkEmailOnAgentRequestData } from '../model/parkEmailOnAgentRequestData';
import { ParkEmailOnSkillRequestData } from '../model/parkEmailOnSkillRequestData';
import { ReQueueEmailRequestData } from '../model/reQueueEmailRequestData';
import { ReassignEmailRequestData } from '../model/reassignEmailRequestData';
import { SendEmailRequestData } from '../model/sendEmailRequestData';
import { SetMessageListSkillFilterRequestData } from '../model/setMessageListSkillFilterRequestData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EmailsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public closeEmail(body?: CloseEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public closeEmail(body?: CloseEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public closeEmail(body?: CloseEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public closeEmail(body?: CloseEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/close`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param contentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAttachment(contentId: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getAttachment(contentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getAttachment(contentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getAttachment(contentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contentId === null || contentId === undefined) {
            throw new Error('Required parameter contentId was null or undefined when calling getAttachment.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/octet-stream'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get',`${this.basePath}/api/emails/attachment/${encodeURIComponent(String(contentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param messageId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmailContent(messageId?: string, observe?: 'body', reportProgress?: boolean): Observable<EmailContentResponse>;
    public getEmailContent(messageId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailContentResponse>>;
    public getEmailContent(messageId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailContentResponse>>;
    public getEmailContent(messageId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (messageId !== undefined && messageId !== null) {
            queryParameters = queryParameters.set('MessageId', <any>messageId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EmailContentResponse>('get',`${this.basePath}/api/emails/content`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEmailTemplate(templateId?: number, observe?: 'body', reportProgress?: boolean): Observable<EmailTemplateResponse>;
    public getEmailTemplate(templateId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailTemplateResponse>>;
    public getEmailTemplate(templateId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailTemplateResponse>>;
    public getEmailTemplate(templateId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (templateId !== undefined && templateId !== null) {
            queryParameters = queryParameters.set('TemplateId', <any>templateId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EmailTemplateResponse>('get',`${this.basePath}/api/emails/template`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param searchValue 
     * @param folderId 
     * @param skillId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFilteredEmails(searchValue?: string, folderId?: number, skillId?: number, observe?: 'body', reportProgress?: boolean): Observable<EmailSearchResponse>;
    public getFilteredEmails(searchValue?: string, folderId?: number, skillId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EmailSearchResponse>>;
    public getFilteredEmails(searchValue?: string, folderId?: number, skillId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EmailSearchResponse>>;
    public getFilteredEmails(searchValue?: string, folderId?: number, skillId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchValue !== undefined && searchValue !== null) {
            queryParameters = queryParameters.set('searchValue', <any>searchValue);
        }
        if (folderId !== undefined && folderId !== null) {
            queryParameters = queryParameters.set('folderId', <any>folderId);
        }
        if (skillId !== undefined && skillId !== null) {
            queryParameters = queryParameters.set('skillId', <any>skillId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EmailSearchResponse>('get',`${this.basePath}/api/emails/filtered`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markEmailActive(body?: MarkEmailActiveRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markEmailActive(body?: MarkEmailActiveRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markEmailActive(body?: MarkEmailActiveRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markEmailActive(body?: MarkEmailActiveRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/mark-active`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public markEmailUndone(body?: MarkEmailUndoneRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public markEmailUndone(body?: MarkEmailUndoneRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public markEmailUndone(body?: MarkEmailUndoneRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public markEmailUndone(body?: MarkEmailUndoneRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/mark-undone`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveEmail(body?: MoveEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public moveEmail(body?: MoveEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public moveEmail(body?: MoveEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public moveEmail(body?: MoveEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/move`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public openEmail(body?: OpenEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public openEmail(body?: OpenEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public openEmail(body?: OpenEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public openEmail(body?: OpenEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/open`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public parkEmailOnAgent(body?: ParkEmailOnAgentRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public parkEmailOnAgent(body?: ParkEmailOnAgentRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public parkEmailOnAgent(body?: ParkEmailOnAgentRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public parkEmailOnAgent(body?: ParkEmailOnAgentRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/park-agent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public parkEmailOnSkill(body?: ParkEmailOnSkillRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public parkEmailOnSkill(body?: ParkEmailOnSkillRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public parkEmailOnSkill(body?: ParkEmailOnSkillRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public parkEmailOnSkill(body?: ParkEmailOnSkillRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/park-skill`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reQueueEmail(body?: ReQueueEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public reQueueEmail(body?: ReQueueEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public reQueueEmail(body?: ReQueueEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public reQueueEmail(body?: ReQueueEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/requeue`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reassignEmail(body?: ReassignEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public reassignEmail(body?: ReassignEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public reassignEmail(body?: ReassignEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public reassignEmail(body?: ReassignEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/reassign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Used to send an email.
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendEmail(body?: SendEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public sendEmail(body?: SendEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public sendEmail(body?: SendEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public sendEmail(body?: SendEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/send`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setMessageListSkillFilter(body?: SetMessageListSkillFilterRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setMessageListSkillFilter(body?: SetMessageListSkillFilterRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setMessageListSkillFilter(body?: SetMessageListSkillFilterRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setMessageListSkillFilter(body?: SetMessageListSkillFilterRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/emails/set-message-list-skill-filter`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
